"use client";

import React from "react";
export default function MethodologyComparison() {
  return <section id="申請流程與表單" className="relative w-full bg-background text-foreground py-24 overflow-hidden">
    </section>;
}